import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { Navigate, Route, Routes } from 'react-router-dom';

import { api } from './api.js';
import { AdminPage } from './pages/AdminPage.js';
import { LoginPage } from './pages/LoginPage.js';
import { MessengerPage } from './pages/MessengerPage.js';

export function App() {
  const queryClient = useQueryClient();
  const session = useQuery({ queryKey: ['session'], queryFn: api.session, retry: false });
  const login = useMutation({
    mutationFn: ({ loginName, password }: { loginName: string; password: string }) =>
      api.login(loginName, password),
    onSuccess: (data) => queryClient.setQueryData(['session'], data),
  });
  const signedOut = () => {
    queryClient.clear();
    void session.refetch();
  };
  const logout = useMutation({ mutationFn: api.logout, onSuccess: signedOut });

  if (session.isLoading) {
    return (
      <main className="loading-page">
        <span className="brand-mark">Р</span>
        <p>Подключаемся…</p>
      </main>
    );
  }
  if (!session.data) {
    return (
      <LoginPage
        pending={login.isPending}
        error={login.error instanceof Error ? login.error.message : null}
        onLogin={(loginName, password) => login.mutate({ loginName, password })}
      />
    );
  }

  const user = session.data.user;
  return (
    <Routes>
      <Route path="/" element={<MessengerPage user={user} onLogout={() => logout.mutate()} />} />
      <Route
        path="/admin"
        element={
          user.role === 'ADMIN' ? <AdminPage currentUser={user} /> : <Navigate to="/" replace />
        }
      />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
